import { render, staticRenderFns } from "./PrimaryIconButton.vue?vue&type=template&id=218a1237&"
import script from "./PrimaryIconButton.vue?vue&type=script&lang=ts&"
export * from "./PrimaryIconButton.vue?vue&type=script&lang=ts&"
import style0 from "./PrimaryIconButton.vue?vue&type=style&index=0&id=218a1237&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports